import { render } from "./SimulatedUserMenu.vue?vue&type=template&id=a9e954de&ts=true"
import script from "./SimulatedUserMenu.vue?vue&type=script&lang=ts"
export * from "./SimulatedUserMenu.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__